import {connect} from 'react-redux';
import React, {Component} from 'react';

import {changeLanguage} from '../../actions/Global';
import {setDateStart, setDateEnd} from '../../actions/ObjectPage';

const defaultProps = {
    setDateEnd: dateEndMoment => {
    },
    setDateStart: dateStartMoment => {
    }
};

class LanguageSelect extends Component {
    constructor(props) {
        super(props);

        this.state = ({
            isVisibleNormal: true,
            ulStyle: {
                opacity: 0,
                visibility: 'hidden'
            }
        });
    }

    handleLanguageClick(event, code) {
        event.preventDefault();

        this.props.changeLanguage(code);

        this.setAllLanguagesVisible(false);
        this.setState(
            {
                isVisibleNormal: false
            },
            () => {
                setTimeout(
                    () => {
                        this.setState({
                            isVisibleNormal: true
                        });
                    },
                    2000
                )
            }
        );
    }

    handleMouseOver = () => {
        this.setAllLanguagesVisible(true);
    };

    handleMouseLeave = () => {
        this.setAllLanguagesVisible(false);
    };

    setAllLanguagesVisible = (isVisible, callback) => {
        if (isVisible && this.state.isVisibleNormal) {
            this.setState({
                ulStyle: {
                    opacity: 1,
                    visibility: 'visible'
                },
                callback
            });
        } else {
            this.setState({
                ulStyle: {
                    opacity: 0,
                    visibility: 'hidden'
                },
                callback
            });
        }
    };

    render() {
        const {currentLanguage, allLanguages} = this.props;

        return (
            <div className="language" onMouseOver={this.handleMouseOver} onMouseLeave={this.handleMouseLeave}>
                {currentLanguage !== undefined && <span>
                    <img src={currentLanguage.imgURL} alt={currentLanguage.code} />
                </span>}
                <ul style={this.state.ulStyle}>
                    {allLanguages.map(language =>
                        <li key={language.code}>
                            <a href="" onClick={event => this.handleLanguageClick(event, language.code)}>
                                <img src={language.imgURL} alt={language.code} />
                            </a>
                        </li>
                    )}
                </ul>
            </div>
        )
    }
}

LanguageSelect.defaultProps = defaultProps;

const mapStateToProps = state => ({
    allLanguages: state.languages.allLanguages,
    dateEndMoment: state.objectPage.dateEndMoment,
    currentLanguage: state.languages.currentLanguage,
    dateStartMoment: state.objectPage.dateStartMoment
});

const mapDispatchToProps = {
    setDateEnd,
    setDateStart,
    changeLanguage
};

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelect);



// WEBPACK FOOTER //
// ./src/components/Base/LanguageSelect.js